// @ngInject
function purchaseOrderAnalysisFilterDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(selectedSupplier,
                suppliers,
                selectedNumberOfResultsPerPage,
                numberOfResultsPerPage,
                selectedArticleCollection,
                articleCollections,
                showAllCollections,
                selectedMainGroup,
                mainGroups,
                selectedWeekLimit,
                weekLimit,
                keepProductTogether,
                showWeeks,
                showProduct,
                includeInactive) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'purchaseOrderAnalysisFilterDialogController as vm',
            templateUrl: 'services/dialogs/purchaseOrderAnalysisFilterDialog/purchaseOrderAnalysisFilterDialog.tpl.html',
            size: 'md'
        };

        modalDefaults.resolve = {
            selectedSupplier: function() {
                return selectedSupplier;
            },
            suppliers: function() {
                return suppliers;
            },
            selectedNumberOfResultsPerPage: function() {
                return selectedNumberOfResultsPerPage;
            },
            numberOfResultsPerPage: function() {
                return numberOfResultsPerPage;
            },
            selectedArticleCollection: function() {
                return selectedArticleCollection;
            },
            articleCollections: function() {
                return articleCollections;
            },
            showAllCollections: function() {
                return showAllCollections;
            },
            selectedMainGroup: function() {
                return selectedMainGroup;
            },
            mainGroups: function() {
                return mainGroups;
            },
            selectedWeekLimit: function() {
                return selectedWeekLimit;
            },
            weekLimit: function() {
                return weekLimit;
            },
            keepProductTogether: function() {
                return keepProductTogether;
            },
            showWeeks: function() {
                return showWeeks;
            },
            showProduct: function() {
                return showProduct;
            },
            includeInactive: function() {
                return includeInactive;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function purchaseOrderAnalysisFilterDialogController($uibModalInstance,
        selectedSupplier,
        suppliers,
        selectedNumberOfResultsPerPage,
        numberOfResultsPerPage,
        selectedArticleCollection,
        articleCollections,
        showAllCollections,
        selectedMainGroup,
        mainGroups,
        selectedWeekLimit,
        weekLimit,
        keepProductTogether,
        showWeeks,
        showProduct,
        includeInactive) {
    var vm = this;

    vm.closeModal = closeModal;
    vm.selectedSupplier = selectedSupplier;
    vm.suppliers = suppliers;
    vm.selectedNumberOfResultsPerPage = selectedNumberOfResultsPerPage;
    vm.numberOfResultsPerPage = numberOfResultsPerPage;
    vm.selectedArticleCollection = selectedArticleCollection;
    vm.articleCollections = articleCollections;
    vm.showAllCollections = showAllCollections;
    vm.selectedMainGroup = selectedMainGroup;
    vm.mainGroups = mainGroups;
    vm.selectedWeekLimit = selectedWeekLimit;
    vm.weekLimit = weekLimit;
    vm.keepProductTogether = keepProductTogether;
    vm.showWeeks = showWeeks;
    vm.showProduct = showProduct;
    vm.includeInactive = includeInactive;

    function closeModal(confirmation) {
        var response = {
            confirmation: confirmation,
            selectedSupplier: vm.selectedSupplier,
            selectedNumberOfResultsPerPage: vm.selectedNumberOfResultsPerPage,
            selectedArticleCollection: vm.selectedArticleCollection,
            showAllCollections: vm.showAllCollections,
            selectedMainGroup: vm.selectedMainGroup,
            selectedWeekLimit: vm.selectedWeekLimit,
            keepProductTogether: vm.keepProductTogether,
            showWeeks: vm.showWeeks,
            showProduct: vm.showProduct,
            includeInactive: vm.includeInactive
        };
        $uibModalInstance.close(response);
    }
}

angular
    .module('services.dialogs.purchaseOrderAnalysisFilterDialog', [])
    .service('purchaseOrderAnalysisFilterDialogService', purchaseOrderAnalysisFilterDialogService)
    .controller('purchaseOrderAnalysisFilterDialogController', purchaseOrderAnalysisFilterDialogController);
